import * as yup from "yup";
import { VALIDATION_REGEX } from "utils/constants";
import i18next from "config/i18next";
import { AccountSchemaParams } from "pages/detailPicker/types";
import { validateFiscalNumber } from "utils/validations";

const requiredMessage = i18next.t("validations:required");

const requiredString = yup.string().required(requiredMessage);
const optionalString = yup.string().optional();
const requiredObject = yup.object().required(requiredMessage);
const optionalObject = yup.object().optional();

export const accountingDataAR = ({
  approve,
  invalidBank,
  duplicatedFiscalNumber,
}: AccountSchemaParams) =>
  yup.object({
    account: yup.object({
      number: yup
        .string()
        .test(
          "invalidBankIdentifier",
          i18next.t("account:invalidBank"),
          () => !invalidBank
        )
        .concat(requiredString)
        .min(22, i18next.t("account:invalidBank"))
        .matches(
          VALIDATION_REGEX.regNumber,
          i18next.t("validations:numbersOnly")
        ),
      bank:
        approve ? requiredObject.nullable() : optionalObject.nullable(),
    }),
    fiscalNumber: yup
      .string()
      .nullable()
      .min(11, i18next.t("account:fiscalNumberError"))
      .test(
        "duplicatedFiscalNumber",
        i18next.t("account:fiscalNumberDuplicated"),
        () => !duplicatedFiscalNumber
      )
      .test("requiredFiscalNumberIfSAP", "", validateFiscalNumber),
    sapInterlocutor: yup
      .string()
      .nullable()
      .test(
        "sapInterlocutorTenDigits",
        i18next.t("account:sapInterlocutorError"),
        (value) => {
          if (value == null || value === "" || value === "-") return true;
          return VALIDATION_REGEX.sapInterlocutorTenDigits.test(value);
        }
      ),
    address: yup.object({
      street: yup
        .string()
        .concat(approve ? requiredString : optionalString)
        .matches(
          VALIDATION_REGEX.regStreet,
          i18next.t("account:formatAddressError")
        ),
      streetNumber: yup
        .string()
        .concat(approve ? requiredString : optionalString)
        .matches(
          VALIDATION_REGEX.regStreet,
          i18next.t("account:formatAddressError")
        ),
      postalCode: approve
        ? yup
            .string()
            .min(4, i18next.t("account:cpError"))
            .required(requiredMessage)
            .matches(
              VALIDATION_REGEX.regNumber,
              i18next.t("validations:numbersOnly")
            )
        : optionalString,
      locality: yup
        .string()
        .concat(approve ? requiredString : optionalString)
        .matches(
          VALIDATION_REGEX.regStreet,
          i18next.t("account:formatAddressError")
        ),
      province: approve ? requiredObject.nullable() : optionalObject.nullable(),
    }),
  });
